import React, { useEffect } from "react";
import toast, { Toaster } from "react-hot-toast";
import { onMessageListener } from "../firebase";
import { toAbsoluteUrl } from "../helpers/Reusable";

// Close icon component
const CloseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={2.5}
    stroke="currentColor"
    style={{ width: 20, height: 20 }}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
);

// Toast content component
const ToastContent = ({ title, body, image, toastId }) => (
  <div style={{ display: "flex", alignItems: "flex-start", gap: 12 }}>
    {image && (
      <img
        src={image}
        alt="icon"
        style={{ width: 48, height: 48, borderRadius: 8, objectFit: "cover" }}
      />
    )}
    <div style={{ flex: 1, minWidth: 0 }}>
      <div
        style={{
          fontSize: 15,
          fontWeight: 700,
          lineHeight: 1.4,
          color: "#ffffff",
          marginBottom: 4,
          wordBreak: "break-word",
        }}
      >
        {title}
      </div>
      <div
        style={{
          fontSize: 13,
          fontWeight: 500,
          lineHeight: 1.5,
          color: "rgba(255,255,255,0.9)",
          wordBreak: "break-word",
        }}
      >
        {body}
      </div>
    </div>

    <button
      onClick={() => toast.dismiss(toastId)}
      style={{
        background: "rgba(255,255,255,0.15)",
        border: "none",
        cursor: "pointer",
        color: "#ffffff",
        padding: 6,
        lineHeight: 1,
        borderRadius: 6,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.2s ease",
        flexShrink: 0,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = "rgba(255,255,255,0.3)";
        e.currentTarget.style.color = "#ff4444";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "rgba(255,255,255,0.15)";
        e.currentTarget.style.color = "#ffffff";
      }}
    >
      <CloseIcon />
    </button>
  </div>
);

const NotificationProvider = ({ children }) => {
  useEffect(() => {
    // Optional: notification sound
    // const notificationSound = new Audio("/notification-sound.mp3");

    const setupListener = async () => {
      try {
        const payload = await onMessageListener();
        console.log("FCM message received:", payload);

        const title = payload?.notification?.title || payload?.data?.title || "New Notification";
        const body = payload?.notification?.body || payload?.data?.body || "You have a new update.";
        const image = payload?.notification?.image || payload?.data?.image || toAbsoluteUrl("media/img/logo/main-logo.svg");

        // Play notification sound (optional)
        // notificationSound.currentTime = 0;
        // notificationSound.play().catch(console.warn);

        toast.custom(
          (t) => (
            <div
              style={{
                background: "linear-gradient(135deg, #c99930 0%, #1e3a5f 100%)",
                backdropFilter: "blur(12px)",
                borderRadius: 14,
                padding: 16,
                minWidth: 320,
                maxWidth: 400,
                boxShadow: "0 8px 32px rgba(0,0,0,0.2), 0 2px 8px rgba(0,0,0,0.1)",
                border: "1px solid rgba(255,255,255,0.2)",
                opacity: t.visible ? 1 : 0,
                transform: t.visible
                  ? "translateY(0) scale(1)"
                  : "translateY(-20px) scale(0.95)",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              }}
            >
              <ToastContent title={title} body={body} image={image} toastId={t.id} />
            </div>
          ),
          { duration: 8000, position: "top-right" }
        );

        // Re-setup listener for next message
        setupListener();
      } catch (error) {
        console.error("Error receiving FCM message:", error);
        // Re-setup listener even on error
        setupListener();
      }
    };

    setupListener();
  }, []);

  return (
    <>
      {children}
      <Toaster
        position="top-right"
        gutter={12}
        containerStyle={{
          top: 20,
          right: 20,
        }}
      />
    </>
  );
};

export default NotificationProvider;
